import { useState, useEffect, useContext } from "react";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState, PollsAnswerType } from "../../../../../models/SKArtifact";

export interface CheckBoxData {
  mode: PollsAnswerType;
  name: string;
  notes?: string;
}

interface AddCheckBoxSetProps {
  index: number;
  title: string;
  note: string;
  setDefaultValue: number;
  answerType: CheckBoxData[];
  onSelect: (selected: CheckBoxData | null) => void;
}

export const AddCheckBoxSet = ({ index, title, note, setDefaultValue, answerType, onSelect }: AddCheckBoxSetProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const { isEditable } = useContext(CreateArtifactContext);

  useEffect(() => {
    if (answerType.length > 0) {
      if (setDefaultValue >= 0 && setDefaultValue < answerType.length) {
        setSelectedIndex(setDefaultValue);
        //onSelect(answerType[setDefaultValue]);
      } else {
        setSelectedIndex(0);
        //onSelect(answerType[0]);
      }
    }
  }, [answerType, setDefaultValue]);

  const handleOptionClick = (data: CheckBoxData, idx: number) => {
    setSelectedIndex(idx);
    onSelect(data);
  };

  const getImageSrc = (idx: number): string => {
    const isSelected = selectedIndex === idx;
    if (isEditable) {
      return isSelected ? "/icons/CheckFilled.png" : "/icons/CheckInactive.png";
    } else {
      return isSelected ? "/icons/checkeditem.png" : "/icons/CheckInactive.png";
    }
  };

  return (
    <div>
      <div className="flex flex-col">
        <div className="flex items-center">
          <span>{index && <span className="content_count">{index}</span>}</span>
          {title && <span className="content_title">{title}</span>}
        </div>
        {note && <div className="notes-class-content">{note}</div>}
        {answerType.map((data, idx) => (
          <div key={idx}>
            <div
              tabIndex={0}
              onClick={isEditable ? () => handleOptionClick(data, idx) : undefined}
              className="flex flex-row first-letter w-full gap-[15px] cursor-pointer border-b mt-[10px] max-w-[486px]"
            >
              <div className="flex items-center justify-center flex-shrink-0 w-5 h-5 border-[1px] rounded-full border-gray">
                <img src={getImageSrc(idx)} className="inline-block h-auto object-fit-contain" alt="" />
              </div>
              <div className="flex flex-col">
                <span className="input-check-box-text">{data.name}</span>
                {data.notes && <span className="notes-class-wo-bt-space">{data.notes}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
